"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EloiseWidget = void 0;
var react_1 = __importStar(require("react"));
var App_1 = require("../../App");
var uuid_1 = require("uuid");
var EloiseWidget = function (_a) {
    var children = _a.children, eloiseIntel = _a.eloiseIntel;
    var _b = (0, App_1.useEloise)(), eloiseContent = _b.eloiseContent, setEloiseContent = _b.setEloiseContent, logic = _b.logic;
    var _c = (0, react_1.useState)((0, uuid_1.v4)()), id = _c[0], setId = _c[1];
    var _d = (0, react_1.useState)(), text = _d[0], setText = _d[1];
    var childRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var test = logic.generic.extractTextFromComponent(children);
        if (test !== text) {
            setText(test);
        }
    }, [children]);
    (0, react_1.useEffect)(function () {
        var ots = __assign(__assign({}, eloiseIntel), { text: logic.generic.extractTextFromComponent(children), id: id });
        // Add ots to eloiseContent when the component mounts
        setEloiseContent(function (prevContent) { return __spreadArray(__spreadArray([], prevContent, true), [ots], false); });
        // Remove ots from eloiseContent when the component unmounts
        return function () {
            setEloiseContent(function (prevContent) {
                return prevContent.filter(function (intel) { return intel.id !== ots.id; });
            });
        };
    }, []);
    // Update text in eloiseContent when children prop changes
    (0, react_1.useEffect)(function () {
        if (!childRef.current)
            return;
        var newText = logic.generic.extractTextFromComponent(children);
        var position = childRef.current.getBoundingClientRect();
        setEloiseContent(function (prevEloiseContent) {
            return prevEloiseContent.map(function (intel) {
                return intel.id === id
                    ? __assign(__assign({}, intel), { text: newText, position: {
                            top: position.top,
                            right: position.right,
                            bottom: position.bottom,
                            left: position.left,
                        } }) : intel;
            });
        });
    }, [text, childRef]);
    return react_1.default.createElement("div", { ref: childRef }, children);
};
exports.EloiseWidget = EloiseWidget;
